/* eslint-disable no-use-before-define */

import { createStyles, makeStyles, Theme, withStyles } from '@material-ui/core/styles';

import React, { FC, ReactNode, useEffect, useRef, useState } from 'react';
import { ReactComponent as Timer } from '../../Asset/svg/timer.svg';

interface TimelineProps {
  timer: number;
  onEnd?: () => void;
};

const TimerTest: FC<TimelineProps> = ({ timer, onEnd }) => {
  const classes = useStyles();
  const [count, setCount] = useState(timer);
  const hasEnded = useRef(false);

  useEffect(() => {
    setCount(timer);
    hasEnded.current = false;
  }, [timer]);

  useEffect(() => {
    if (count <= 0) {
      if (onEnd && !hasEnded.current) {
        hasEnded.current = true;
        onEnd();
      }
      return;
    }

    const interval = setInterval(() => {
      setCount((prev) => prev - 1);
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [count, onEnd]);

  return (
    <div className={classes.content}>
      <div className={classes.iconTime}>
        <Timer />
      </div>
      <div className={classes.counterTime}>
        <span>{count}</span>sec.
      </div>
    </div>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    content: {
      display: 'flex',
    },
    iconTime: {
      width: 30,
      height: 30,
      backgroundColor: '#000A8C',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginRight: 5,
      borderRadius: 20,
    },
    counterTime: {
      backgroundColor: '#000A8C',
      height: 30,
      borderRadius: 20,
      color: 'white',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight: 400,
      paddingLeft: 15,
      paddingRight: 15,
      fontFamily: 'Poppins',
      '& span': {
        fontWeight: 700,
        color: 'white',
        fontFamily: 'Poppins',
        marginRight: 4,
      },
    },
  })
);
export default TimerTest;
